import { Navigate, useParams } from 'react-router-dom';

import { PermissionsEnum } from '@/auth/interfaces';
import { ROUTER_PATHS, useCheckPermissions, useLoaders } from '@/shared';
import { useGetEmpresa } from '@/shared/actions/erp';
import SaveEmpresa from '../../shared/components/SaveEmpresa/SaveEmpresa';

export interface UpdateEmpresaPageProps {}

const UpdateEmpresaPage: React.FC<UpdateEmpresaPageProps> = () => {
  useCheckPermissions(PermissionsEnum.api_change_empresa);
  const returnUrlEmpresasPage = ROUTER_PATHS.administration.empresaNav;

  const { id } = useParams();
  const { data, isLoading, isRefetching } = useGetEmpresa(id!);

  useLoaders(isLoading);

  if (isLoading || isRefetching) return null;
  if (!data?.data?.id_empresa)
    return <Navigate to={returnUrlEmpresasPage} replace />;

  return <SaveEmpresa titlePage="Editar Empresa" editEmpresa={data.data} />;
};

export default UpdateEmpresaPage;
